import { API_CONSTANTS } from "../../constants/apiConstants";
import baseApi from "./baseApiService";
export const clinicApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getClinicUserDetails: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_CLINIC_USER_DETAILS}`,
        method: "Post",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        body: JSON.stringify(request),
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),
    updateClinicUserDetails: builder.query({
      query: (updateRequest) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.UPDATE_CLINIC_USER_INFO}`,
        method: "POST",
        headers: {
          "content-type": "application/json",
          Accept: "*/*",
        },
        body: JSON.stringify(updateRequest),
        credentials: "include",
      }),
    }),
    GetProviderData: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_PROVIDER_DATA}`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        body: JSON.stringify(request),
        credentials: "include",
      }),
    }),
    GetClinicLicenses: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_CLINIC_LICENSES}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    AssignProvider: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.ASSIGN_PROVIDER}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),
    UnassignProvider: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.UNASSIGN_PROVIDER}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    deleteClinicLogo: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.DELETE_CLINIC_LOGO}`,
        method: "DELETE",
        body: JSON.stringify(request),
        headers: {
          "content-type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    getManageSubscriptionUrl: builder.query({
      query: () => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.CREATE_PORTAL_SESSION}`,
        method: "GET",
        headers: {
          "Content-Type": "*/*",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    isBpSiteIdVerified: builder.query({
      query: () => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.IS_BP_SITE_ID_VERIFIED}`,
        method: "GET",
        headers: {
          "Content-Type": "*/*",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
    getAllClinics: builder.query({
      query: (request) => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_ALL_CLINICS}`,
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        credentials: "include",
      }),
      keepUnusedDataFor: 0,
    }),
    getAllClinicNames: builder.query({
      query: () => ({
        url: `${API_CONSTANTS.EVO_PORTAL_BASE_URL}${API_CONSTANTS.GET_ALL_CLINIC_NAMES}`,
        method: "GET",
        headers: {
          "Content-Type": "*/*",
          Accept: "*/*",
        },
        credentials: "include",
      }),
    }),
  }),
});
export const {
  useGetClinicUserDetailsQuery,
  useLazyUpdateClinicUserDetailsQuery,
  useLazyGetProviderDataQuery,
  useLazyGetClinicLicensesQuery,
  useLazyAssignProviderQuery,
  useLazyUnassignProviderQuery,
  useLazyDeleteClinicLogoQuery,
  useLazyGetManageSubscriptionUrlQuery,
  useIsBpSiteIdVerifiedQuery,
  useLazyGetAllClinicsQuery,
  useGetAllClinicNamesQuery,
} = clinicApi;
